import React, { useLayoutEffect, useRef } from 'react';
import { Icon, Input } from 'antd';
import { useFieldController } from '../../../helpers/formManager';
import FormFieldItem from './FormFieldItem';
import { PHONE_LENGTH, fieldNames } from '../constants';
import {
  countDigitsBeforeIndex,
  formatPhone,
  getCursorPositionForDigitCount,
  normalizePhone,
} from '../utils';

const rules = {
  validate: (value) => {
    if (!value) return 'Укажите телефон';
    if (value.length !== PHONE_LENGTH)
      return 'Номер телефона должен включать 10 цифр';
    return true;
  },
};

const PhoneField = ({ control, loading }) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useFieldController({ control, name: fieldNames.phone, rules });

  const inputRef = useRef(null);
  const pendingDigitCountRef = useRef(null);

  const formattedValue = formatPhone(value);

  const handleChange = (event) => {
    const { value: rawValue, selectionStart } = event.target;

    pendingDigitCountRef.current = countDigitsBeforeIndex(
      rawValue,
      selectionStart
    );
    onChange(normalizePhone(rawValue));
  };

  useLayoutEffect(() => {
    if (pendingDigitCountRef.current === null) return;

    const position = getCursorPositionForDigitCount(
      formattedValue,
      pendingDigitCountRef.current
    );
    pendingDigitCountRef.current = null;

    if (inputRef.current?.input) {
      inputRef.current.input.setSelectionRange(position, position);
    }
  }, [formattedValue]);

  return (
    <FormFieldItem label="Телефон" required errorMessage={error?.message}>
      <Input
        ref={inputRef}
        value={formattedValue}
        onChange={handleChange}
        addonBefore="+7"
        placeholder="(xxx) xxx-xx-xx"
        suffix={loading ? <Icon type="loading" /> : <span />}
      />
    </FormFieldItem>
  );
};

export default PhoneField;
